import { render, staticRenderFns } from "./CourseSalesReportPanel.vue?vue&type=template&id=8277117c&scoped=true"
import script from "./CourseSalesReportPanel.vue?vue&type=script&lang=js"
export * from "./CourseSalesReportPanel.vue?vue&type=script&lang=js"
import style0 from "./CourseSalesReportPanel.vue?vue&type=style&index=0&id=8277117c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8277117c",
  null
  
)

export default component.exports